import { Flex } from "@mantine/core";

export const CardEmptyValue = (
  <Flex justify="start" align="center">
    {" "}
    —{" "}
  </Flex>
);
